import { useMemo } from 'react';

import { MarginTransactionType } from '@swyftx/margin/build/types';

import { useMarkets } from 'src/lib/markets/hooks/useMarkets';

import { useMarginTransactions } from './useMarginTransactions';
import { MarginTransactionDirection } from '../../types';

type Props = {
  transactionId: string;
  type: MarginTransactionType[];
};

const useMarginTransactionDetails = ({ transactionId, type }: Props) => {
  const { getTransactionById } = useMarginTransactions({ type });
  const { getAssetByUuid } = useMarkets();

  const transaction = useMemo(() => getTransactionById(transactionId), [getTransactionById, transactionId]);

  const asset = useMemo(() => getAssetByUuid(transaction?.assetId), [getAssetByUuid, transaction?.assetId]);

  const transferFrom = useMemo(
    () => (transaction?.type === 'DEPOSIT' ? MarginTransactionDirection.Spot : MarginTransactionDirection.Derivatives),
    [transaction?.type],
  );

  const transferTo = useMemo(
    () => (transaction?.type === 'DEPOSIT' ? MarginTransactionDirection.Derivatives : MarginTransactionDirection.Spot),
    [transaction?.type],
  );

  return {
    transaction,
    asset,
    transferFrom,
    transferTo,
  };
};

export { useMarginTransactionDetails };
